export const es = {
  ns1: {
    "A newer version of the app opened a window. Reload to continue.":
      "Una versión más reciente de la aplicación abrió una ventana. Recarga para continuar.",
    Reload: "Recargar",
    "Could not load local servers":
      "No se pudieron cargar los servidores locales",
    "Toasts won't appear on small screens. Only the bell icon will show a notification in that case.":
      "Los toasts no aparecen en pantallas pequeñas. En ese caso, solo el icono de la campana mostrará la notificación.",
    "Toast notifications remain on the screen until dismissed. Critical notifications will appear in red.":
      "Las notificaciones toast permanecen en pantalla hasta que se descarten. Las notificaciones críticas aparecerán en rojo.",
    "No internet connection": "Sin conexión a internet",
    pen_with_id: "Jaula {{cageId}}",
    "Failed to move camera": "Error al mover la cámara",
    Recording: "Grabación",
    "Event clip": "Clip de evento",
    "Failed to save preset": "Error al guardar la preconfiguración",
    "Failed to delete preset": "Error al eliminar la preconfiguración",
    "Save camera preset": "Guardar preconfiguración de cámara",
    "These coordinates will be saved with the preset.":
      "Estas coordenadas se guardarán con la preconfiguración.",
    "X offset": "Desplazamiento X",
    "e.g. North feed point": "p. ej. Punto de alimentación norte",
    "Delete preset": "Eliminar preconfiguración",
    "Preset name": "Nombre de la preconfiguración",
    Required: "Obligatorio",
    "Configure cage dimensions to view the digital twin":
      "Configure las dimensiones de la jaula para ver el gemelo digital",
    Expand: "Expandir",
    Collapse: "Contraer",
    "Expand digital twin": "Expandir gemelo digital",
    "Add to favourites": "Añadir a favoritos",
    "Remove from favourites": "Quitar de favoritos",
    "Return to live": "Volver a en vivo",
    "Loading chart data...": "Cargando datos del gráfico...",
    "Error loading data": "Error al cargar los datos",
    server_not_found: "No se encontró ningún servidor en {{ip}}:{{port}}.",
    "Feeding only": "Solo alimentación",
    Map: "Mapa",
    User: "Usuario",
    Users: "Usuarios",
    Logout: "Cerrar sesión",
    "No sites available": "No hay centros disponibles",
    "Loading sites": "Cargando centros",
    "No site selected_other": "No se ha seleccionado ningún centro",
    "No site selected_one": "No se ha seleccionado ningún centro",
    "Are you sure?": "¿Estás seguro?",
    "This action is irreversible.": "Esta acción es irreversible.",
    Delete: "Eliminar",
    Events: "Eventos",
    "No data available": "No hay datos disponibles",
    "No data for the selected time frame":
      "No hay datos para el intervalo de tiempo seleccionado",
    "New Scenario": "Nuevo Escenario",
    "New Strategy": "Nueva Estrategia",
    "Rename Strategy": "Renombrar Estrategia",
    "Add Strategy": "Agregar Estrategia",
    "Add Scenario": "Agregar Escenario",
    "Edit Scenario": "Editar Escenario",
    "Delete Scenario": "Eliminar Escenario",
    "Delete Strategy": "Eliminar Estrategia",
    "Rename Scenario": "Renombrar Escenario",
    New: "Nuevo",
    "New from": "Nuevo desde",
    "No events in the last 15 minutes":
      "No hay eventos en los últimos 15 minutos",
    "Loading events": "Cargando eventos",
    Unit: "Jaula",
    Pens: "Jaulas",
    Pen: "Jaula",
    All: "Todos",
    Units: "Jaulas",
    Reasons: "Razones",
    "Manual Feeding": "Alimentación Manual",
    "Observe Feeding": "Alimentación de Observe",
    "Planned Feeding": "Alimentación Planificada",
    "Disabled Feeding": "Alimentación Desactivada",
    "Feed actions": "Acciones de alimentación",
    "No data available for current filter(s)":
      "No hay datos disponibles para los filtros actuales",
    "Air speed": "Velocidad del Aire",
    Silo: "Silo",
    Visits: "Visitas",
    Visit: "Visita",
    Automation: "Automatización",
    Auto: "Auto",
    "Live Feeding": "Alimentación en Vivo",
    Live: "En Vivo",
    Analytics: "Analíticas",
    Data: "Datos",
    "Activity change": "Cambio de Actividad",
    Alert: "Alerta",
    "Automation: Scenario change": "Automatización: Cambio de Escenario",
    "Manual scenario change": "Cambio de Escenario Manual",
    "Feeding system change": "Cambio de Sistema de Alimentación",
    "Oxygen change": "Cambio de Oxígeno",
    "Salinity change": "Cambio de Salinidad",
    "Temperature change": "Cambio de Temperatura",
    "Multiple sites": "Múltiples centros",
    "All units": "Todas las jaulas",
    numberOfUnits: "{{numberOfUnits}} jaulas",
    unitId: "Jaula {{unit}}",
    "Invalid username or password": "Nombre de usuario o contraseña inválidos",
    "Your password needs to be reset. You will have received a verification code in your email.":
      "Tu contraseña necesita ser restablecida. Habrás recibido un código de verificación en tu correo electrónico.",
    "If the account exists, you will have received a verification code in your email.":
      "Si la cuenta existe, habrás recibido un código de verificación en tu correo electrónico.",
    "Invalid code or session": "Código o sesión inválidos",
    "Password successfully changed": "Contraseña cambiada exitosamente",
    "Invalid new password": "Nueva contraseña inválida",
    "Password has been successfully changed. Use to log in from now on.":
      "La contraseña se ha cambiado correctamente. Utilízala para iniciar sesión de ahora en adelante.",
    "OTP client successfully set up. Now you can log in":
      "Cliente OTP configurado correctamente. Ahora puedes iniciar sesión",
    "Could not set up the OTP client": "No se pudo configurar el cliente OTP",
    "Feed units": "Unidades de Alimentación",
    Filter: "Filtrar",
    "No units are feeding at the moment":
      "No hay jaulas alimentándose en este momento",
    "No units available": "No hay jaulas disponibles",
    "Remove filter": "Eliminar filtro",
    "Feeding mode": "Modo de Alimentación",
    Strategy: "Estrategia",
    Scenario: "Escenario",
    "Strategies not synced": "Estrategias no sincronizadas",
    Overview: "Resumen",
    "Search site": "Buscar centro",
    "No results": "Sin resultados",
    "Select All": "Seleccionar Todo",
    Loading: "Cargando",
    "Alert Groups": "Grupos de Alerta",
    "No groups found": "No se encontraron grupos",
    Cancel: "Cancelar",
    Save: "Guardar",
    "Discard changes?": "¿Descartar cambios?",
    "You'll lose all changes made to this scenario":
      "Perderás todos los cambios realizados en este escenario",
    "More Than": "Más que",
    "Less Than": "Menos que",
    Calendar: "Calendario",
    Rotas: "Turnos",
    Comments: "Comentarios",
    "Clear Rota": "Limpiar Turno",
    "Add Rota": "Agregar Turno",
    Farmer: "Granjero",
    "Create Farmer": "Crear Granjero",
    "Add rota": "Agregar turno",
    "rota will be overwritten_one": "{{count}} turno será sobrescrito",
    "rota will be overwritten_other": "{{count}} turnos serán sobrescritos",
    Warning: "Advertencia",
    "Email already exists": "El correo electrónico ya existe",
    "Error creating user": "Error al crear usuario",
    "Error creating rota": "Error al crear turno",
    Comment: "Comentario",
    "To Comment": "Comentar",
    "Add comment": "Añadir comentario",
    Presets: "Preajustes",
    Submit: "Enviar",
    "Error creating comment": "Error al crear comentario",
    Now: "Ahora",
    "All day": "Todo el día",
    "No comments": "Sin comentarios",
    Goals: "Objetivos",
    Subgoal: "Subobjetivo",
    Score: "Puntuación",
    "See Examples": "Ver Ejemplos",
    "Show Conditions": "Mostrar Condiciones",
    Disable: "Desactivar",
    Enable: "Activar",
    "No goals found": "No se encontraron objetivos",
    "No data": "Sin datos",
    "Save Changes": "Guardar Cambios",
    "Couldn't update configuration.": "No se pudo actualizar la configuración.",
    "No configuration available for this goal.":
      "No hay configuración disponible para este objetivo.",
    "Configuration updated successfully.":
      "Configuración actualizada exitosamente.",
    "No pens were updated. Changes apply only to active (non-fallowed) pens.":
      "No se actualizaron corrales. Los cambios se aplican solo a corrales activos (no en barbecho).",
    Example: "Ejemplo",
    Breakdown: "Desglose",
    "No breakdown available": "No hay desglose disponible",
    "Sort by": "Ordenar por",
    "Date: Newest to Oldest": "Fecha: De más reciente a más antigua",
    "Date: Oldest to Newest": "Fecha: De más antigua a más reciente",
    "Score: Best to Worst": "Puntuación: De mejor a peor",
    "Score: Worst to Best": "Puntuación: De peor a mejor",
    Evidence: "Evidencia",
    Filters: "Filtros",
    "Configurations updated successfully":
      "Configuraciones actualizadas correctamente",
    "No evidence found for this date range":
      "No se encontró evidencia para este rango de fechas",
    "Access Denied": "Acceso Denegado",
    "You don't have access to this page": "No tienes acceso a esta página",
    "Please contact your administrator":
      "Por favor, contacta a tu administrador",
    or: "o",
    "Sign out": "Cerrar sesión",
    Summary: "Resumen",
    "Shift Analysis": "Análisis de Turno",
    "Days of note for": "Días de interés para {{name}}",
    "Pens for": "Jaulas para {{name}}",
    Analyse: "Analizar",
    "Highest Performing Sites": "Centros con Mejor Rendimiento",
    "Lowest Performing Sites": "Centros con Peor Rendimiento",
    Goal: "Objetivo",
    "No sites with scores found": "No se encontraron centros con puntuaciones",
    "Camera Automation": "Automatización de Cámaras",
    Camera: "Cámara",
    "Feed Automation": "Automatización de Alimentación",
    Feed: "Alimentación",
    Line: "Línea",
    "Feed Rate (Kg/min)": "Tasa de Alimentación (Kg/min)",
    "Visit (Kgs)": "Visita (Kgs)",
    "No strategies found": "No se encontraron estrategias",
    "When pen": "Cuando la jaula",
    "is feeding, use preset": "si está alimentándose, usar preconfiguración",
    "Add Preset": "Agregar Preconfiguración",
    "Edit Preset": "Editar Preconfiguración",
    Add: "Agregar",
    Edit: "Editar",
    Configuration: "Configuración",
    admin_configuration: "Configuración de Administrador",
    notifications_center: "Centro de Notificaciones",
    notifications_center_message:
      "Esta página te permite suscribirte y configurar alertas directamente a tu correo electrónico, así como informes de optimización más detallados",
    create_new: "Crear Nuevo",
    notification_updated_successfully:
      "Notificación actualizada correctamente.",
    When: "Cuando",
    "is feeding": "está alimentándose",
    "use preset": "usar preconfiguración",
    "You will no longer see scores for":
      "Ya no verás puntuaciones para {{name}} a partir de ahora",
    "Error deleting comment": "Error al eliminar comentario",
    "Daily Average": "Promedio Diario",
    "No sites selected": "No se han seleccionado centros",
    environmental: "Ambiental",
    predators: "Predadores",
    camera: "Problema de Hardware de Cámara",
    feed_system: "Problema de Sistema de Alimentación",
    net_cleaning: "Limpieza de Redes",
    mortality: "Mortalidad",
    Language: "Idioma",
    Alerts: "Alertas",
    "Remove Pin": "Quitar fijación",
    "This pen": "Esta jaula",
    "Alerts on this pen": "Alertas en esta jaula",
    "Alerts on {{feedline}}": "Alertas en {{feedline}}",
    "Pinned to {{feedline}}": "Fijado a {{feedline}}",
    "Will move pin from another cell": "Moverá la fijación de otra celda",
    "{{name}} (current)": "{{name}} (actual)",
    "{{provider}} Planner": "{{provider}} Planner",
    Pellets: "Pellets",
    Activity: "Actividad",
    Oxygen: "Oxígeno",
    Graph: "Gráfico",
    "Feed Graph": "Gráfico de Alimentación",
    "Pressure Graph": "Gráfico de Presión",
    "Feed Amount": "Cantidad de Alimento",
    "Feed Rate": "Tasa de Alimentación",
    "Set Feed Rate": "Definir Tasa de Alimentación",
    "Enter feed rate": "Introduce la tasa de alimentación",
    "Feed Status": "Estado de Alimentación",
    "Feed target": "Objetivo de Alimentación",
    "Appetite Factor": "Factor de Apetito",
    "Stopping Depth": "Profundidad de cesación",
    "Create User": "Crear Usuario",
    Shifts: "Turnos",
    Confirm: "Confirmar",
    "First name": "Nombre",
    "Last name": "Apellido",
    Email: "Correo Electrónico",
    Emails: "Correos electrónicos",
    "Email Type": "Tipo de correo",
    Depth: "Profundidad",
    Name: "Nombre",
    Create: "Crear",
    Rename: "Renombrar",
    Dome: "Domo",
    Descent: "Descenso",
    Type: "Tipo",
    "Add Starting Depth": "Agregar Profundidad Inicial",
    "Add Stopping Depth": "Agregar Profundidad de Detención",
    "Add Depth": "Agregar Profundidad",
    "Continuously rotate camera": "Rotar cámara continuamente",
    "Tilt camera down before rotation":
      "Inclinar cámara hacia abajo antes de rotar",
    "Rotate for": "Rotar durante",
    "Pause Between": "Pausa entre barridos",
    "Alternate Direction Each Sweep": "Alternar dirección en cada barrido",
    "Sweeps Each Direction": "Barridos en cada dirección",
    "Go to starting position (end of visit)":
      "Ir a la posición inicial (fin de la visita)",
    "Point camera down": "Apuntar cámara hacia abajo",
    "depth must be bellow": "La profundidad debe ser inferior a {{minDepth}}m",
    "depth must be above": "La profundidad debe ser superior a {{maxDepth}}m",
    "Depth is already used": "La profundidad ya está en uso",
    "What should the camera do?": "¿Qué debería hacer la cámara?",
    "What depth?": "¿Qué profundidad?",
    "When does the camera go up?": "¿Cuándo sube la cámara?",
    "When does the camera go down?": "¿Cuándo baja la cámara?",
    "Create Pause": "Crear Pausa",
    "Edit Pause": "Editar Pausa",
    "Seconds to Pause": "Segundos para Pausa",
    Columns: "Columnas",
    Total: "Total",
    "Best Score": "Mejor Puntuación",
    "Worst Score": "Peor Puntuación",
    Site: "Centro",
    Machine: "Máquina",
    Weeks: "Semanas",
    "Least Pellets": "Menos Pellets",
    "Most Pellets": "Más Pellets",
    "Pellets & Alerts": "Pellets & Alertas",
    "Pellets/Alert": "Pellets/Alerta",
    "Severity [%]": "Severidad [%]",
    "Feed Amount [kg]": "Cantidad de Alimento [kg]",
    "Feed Rate [kg/min]": "Tasa de Alimentación [kg/min]",
    "Feed Time [min]": "Tiempo de Alimentación [min]",
    "Feed Dose [kg]": "Dosis de Alimentación [kg]",
    "Feed Amount/Pellet [kg/Pellet]": "Cantidad de Alimento/Pellet [kg/Pellet]",
    "Alert Responsiveness": "Capacidad de Respuesta a las Alertas",
    "Total Responsiveness [%]": "Capacidad de Respuesta Total [%]",
    "Camera Responsiveness [%]": "Capacidad de Respuesta de Cámara [%]",
    "Feeding Responsiveness [%]": "Capacidad de Respuesta de Alimentación [%]",
    "Alert Activity [%]": "Actividad de Alerta [%]",
    "Feeding Activity [%]": "Actividad de Alimentación [%]",
    "Camera Depth": "Profundidad de Cámara",
    "Camera Action": "Acción de Cámara",
    "Hold & watch": "Mantener y observar",
    "Rotate to scan": "Rotar para escanear",
    "Camera Movement": "Movimiento de Cámara",
    "Depth increasing": "Profundidad aumentando",
    "Depth decreasing": "Profundidad disminuyendo",
    Temperature: "Temperatura",
    "Pipe Pressure": "Presión de Tubería",
    "Feeding Depth": "Profundidad de Alimentación",
    "Alert Depth": "Profundidad de Alerta",
    Sensors: "Sensores",
    "Selected sensor is unavailable, showing another source":
      "El sensor seleccionado no está disponible, se muestra otra fuente",
    Automatic: "Automático",
    "camera's own": "propio de la cámara",
    "No sensor of this type on the pen":
      "No hay sensor de este tipo en la jaula",
    "Failed to save the camera's sensor":
      "No se pudo guardar el sensor de la cámara",
    "Sensors this camera reads": "Sensores que lee esta cámara",
    "Sensors at camera depth": "Sensores a la profundidad de la cámara",
    "Save to choose sensors for the new pen":
      "Guarde para elegir sensores de la nueva jaula",
    "Could not load this camera's sensors":
      "No se pudieron cargar los sensores de esta cámara",
    Custom: "Personalizado",
    "None on this pen": "Ninguno en esta jaula",
    Winch: "Cabrestante",
    "Advanced settings": "Configuración avanzada",
    "Assign this camera to a pen to choose its sensors":
      "Asigna esta cámara a una jaula para elegir sus sensores",
    "Edit Camera": "Editar Cámara",
    "Add Camera": "Agregar Cámara",
    "Edit Winch": "Editar Cabrestante",
    "Add Winch": "Agregar Cabrestante",
    "Winch Type": "Tipo de Cabrestante",
    "Edit Pen": "Editar Jaula",
    "Add Pen": "Agregar Jaula",
    "Edit Sensor": "Editar Sensor",
    "Add Sensor": "Agregar Sensor",
    Connected: "Conectada",
    "Not connected": "No conectada",
    "Oxygen 0-6m": "Oxígeno 0-6m",
    "Feeding Oxygen 0-6m": "Oxígeno en Alimentación 0-6m",
    "Temperature 0-6m": "Temperatura 0-6m",
    "Most Feed Amount/Pellet": "Más Cantidad de Alimento/Bolita",
    "Least Feed Amount/Pellet": "Menos Cantidad de Alimento/Bolita",
    Biomass: "Biomasa",
    "Average Growth [kg]": "Crecimiento Promedio [kg]",
    "Average Weight [kg]": "Peso Promedio [kg]",
    "Highest Weight [kg]": "Peso Más Alto [kg]",
    "Lowest Weight [kg]": "Peso Más Bajo [kg]",
    "Highest Growth [kg]": "Crecimiento Más Alto [kg]",
    "Lowest Growth [kg]": "Crecimiento Más Bajo [kg]",
    en: "English",
    es: "Español",
    no: "Norsk",
    "Admin Configuration": "Configuración de Admin",
    Notifications: "Notificaciones",
    Groups: "Grupos",
    "Show scheduler visit groups": "Mostrar grupos de visitas del planificador",
    "Group {{number}} · {{start}}–{{end}} · {{visits}} visits · {{percent}}%":
      "Grupo {{number}} · {{start}}–{{end}} · {{visits}} visitas · {{percent}}%",
    "Main Menu": "Menú Principal",
    Overfeeding: "Sobrealimentación",
    Underfeeding: "Alimentación insuficiente",
    Standardization: "Normalización",
    "Are there any pellet spikes?": "¿Hay picos de pellets?",
    "Which units stand out?": "¿Qué unidades se destacan?",
    "Pellets/Feed Amount": "Pellets/Cantidad de Alimentación",
    "Feed Amount/Pellet": "Cantidad de Alimentación/Pellet",
    "Overfeeding Feed Deviation": "Desviación de Alimentación excesiva",
    "Feeding Response": "Respuesta de Alimentación",
    "Underfeeding Feed Deviation": "Desviación de Alimentación insuficiente",
    "Limit Grazing": "Limitar el Pastoreo",
    Satiation: "Saciación",
    "Camera Movements": "Movimientos de la Cámara",
    "Feed Profile Smoothness": "Suavidad del perfil de alimentación",
    "Which days of feeding should I pay attention to?":
      "¿A qué días de alimentación debo prestar atención?",
    "Pellet Spike": "Pico de Pellets",
    "Is the feed rate adapting to the fish enough?":
      "¿La tasa de alimentación se adapta lo suficiente a los peces?",
    "Where could we potentially push the feeding further?":
      "¿Dónde podríamos potencialmente aumentar la alimentación?",
    "Are the cameras being optimally positioned?":
      "¿Están las cámaras posicionadas de manera óptima?",
    "What trends are consistent on my site?":
      "¿Qué tendencias son consistentes en mi sitio?",
    Grazing: "Pastoreo",
    Severity: "Severidad",
    "What would you like to track?": "¿Qué te gustaría rastrear?",
    "User sites": "Sitios de usuario",
    "User permission groups": "Grupos de permisos de usuario",
    "Something has gone wrong": "Algo ha salido mal",
    Error: "Error",
    Refresh: "Actualizar",
    Retry: "Reintentar",
    "This page could not be loaded": "No se pudo cargar esta página",
    "Could not connect to the server": "No se pudo conectar con el servidor",
    "The app could not start": "No se pudo iniciar la aplicación",
    "Try again. If it keeps happening, contact support.":
      "Inténtalo de nuevo. Si sigue ocurriendo, contacta con soporte.",
    "Check your network connection and try again.":
      "Comprueba tu conexión de red e inténtalo de nuevo.",
    "You cannot change your own permissions":
      "No puedes cambiar tus propios permisos",
    "Page Not Found": "Página No Encontrada",
    "The page you are looking for doesn't exist":
      "La página que estás buscando no existe",
    "Please check the URL or try navigating to another page":
      "Por favor, verifica la URL o intenta navegar a otra página",
    "Go to Home": "Ir a Inicio",
    "Video Page Layout": "Diseño de Página de Video",
    "Camera Layout": "Diseño de Cámara",
    "Video Aspect Ratio": "Relación de Aspecto de Video",
    Original: "Original",
    Stretch: "Estirar",
    Crop: "Recortar",
    cage_id: "Id de Jaula",
    "Screen Configuration": "Configuración de Pantalla",
    "Save Current Configuration": "Guardar Actual",
    "Reset to Default Configuration": "Restablecer por Defecto",
    "Save Current Configuration Description":
      "Guardar tu configuración actual de pantalla para recordar qué pantallas son visibles",
    "Default Graph Time Range":
      "Intervalo de tiempo predeterminado del gráfico",
    "Camera in Camera": "Cámara en cámara",
    "Camera size": "Tamaño de la cámara",
    Small: "Pequeño",
    Medium: "Mediano",
    Large: "Grande",
    "Pellet Detection": "Detección de Pellets",
    "Render Detections": "Mostrar Detecciones",
    None: "Ninguno",
    "Reset to Default Configuration Description":
      "Restablecer todas las pantallas para mostrar por defecto",
    "Saving...": "Guardando...",
    "Resetting...": "Restableciendo...",
    "Saved!": "¡Guardado!",
    use_acv4_mapping: "Mover cámaras en ACv4 para mover en Observe",
    use_observe_endpoints:
      "Usar endpoints API de Observe (predeterminado: SEAV)",
    "Welcome to Observe Tide!": "¡Bienvenido a Observe Tide!",
    "Use the ": "Usa la ",
    "to select a page": "para seleccionar una página",
    "within a span of": "dentro de un lapso de",
    "Download Config": "Descargar Configuración",
    "Upload Config": "Subir Configuración",
    feeding: "Alimentación",
    general_info: "Información General",
    equipment_challenges: "Problemas de Equipo",
    treatment: "Tratamiento",
    harvest: "Cosecha",
    "Visit created": "Visita creada",
    "Visit deleted": "Visita eliminada",
    "Feeding Settings": "Configuración de Alimentación",
    Copilot: "Copilot",
    Manual: "Manual",
    "Add server": "Agregar servidor",
    "Copy from site": "Copiar desde centro",
    "Data Router": "Enrutador de Datos",
    "Equipment Integration": "Integración de Equipos",
    "for more than": "durante más de",
    "integration for": "Integración para",
    "Local Configuration": "Configuración Local",
    "Local Servers": "Servidores Locales",
    "Notification Settings": "Configuración de Notificaciones",
    "Video Page Settings": "Configuración de Página de Video",
    General: "General",
    "Default Info Rows": "Filas de información predeterminadas",
    "Reset to defaults": "Restablecer valores predeterminados",
    "Saving replaces the info rows on every camera on the video page.":
      "Al guardar se reemplazan las filas de información de todas las cámaras de la página de video.",
    "Row 1": "Fila 1",
    "Row 2": "Fila 2",
    "Row 3": "Fila 3",
    "Time range": "Intervalo de tiempo",
    "Settings saved successfully": "Configuración guardada correctamente",
    "Failed to save settings": "Error al guardar la configuración",
    "Failed to load settings": "Error al cargar la configuración",
    "Site has no cages": "El centro no tiene jaulas",
    "This site is not running the latest Marlin. Upgrade for the latest features.":
      "Este centro no está ejecutando la última versión de Marlin. Actualiza para obtener las últimas funciones.",
    camera_service: "Servicio de Cámara",
    Connection: "Conexión",
    Copy: "Copiar",
    Defaults: "Predeterminados",
    feed_service: "Servicio de Alimentación",
    Feeding: "Alimentación",
    for: "para",
    Integrations: "Integraciones",
    Local: "Local",
    Notification_updated_successfully: "Notificación actualizada correctamente",
    other: "Otro",
    Port: "Puerto",
    seconds: "segundos",
    Servers: "Servidores",
    Settings: "Configuración",
    Sites: "Centros",
    Support: "Soporte",
    Troubleshooting: "Solución de problemas",
    Video: "Video",
    Address: "Dirección",
    Cloud: "Nube",
    Dashboard: "Panel",
    Default: "Predeterminado",
    Group: "Grupo",
    "Integration provider": "Proveedor de integración",
    License: "Licencia",
    Q: "P",
    Version: "Versión",
    "and this occured": "y esto ocurrió",
    once: "una vez",
    "times within a span of": "veces dentro de un lapso de",
    "View active schedule": "Ver programa activo",
    "More info": "Más información",
    Advanced: "Avanzado",
    Fixed: "Fijo",
    "Growth Model": "Modelo de crecimiento",
    "What would you like to call this default?":
      "¿Cómo te gustaría llamar a este plan?",
    "What time does your feeding day start?":
      "¿A qué hora empieza tu día de alimentación?",
    "What time does your feeding day end?":
      "¿A qué hora termina tu día de alimentación?",
    "How is the daily target determined?":
      "¿Cómo se determina el objetivo diario?",
    "How much are you aiming to feed today?": "¿Cuánto quieres alimentar hoy?",
    "What is your average base feed rate across this day?":
      "¿Cuál es tu velocidad de alimentación base promedio a lo largo del día?",
    "Allowed overshoot": "Exceso permitido",
    "Spread feed evenly across the day":
      "Repartir el alimento uniformemente a lo largo del día",
    "Follow recent feed rate": "Seguir la velocidad de alimentación reciente",
    "How are the fish fed?": "¿Cómo se alimentan los peces?",
    "Meal Feeding": "Alimentación por comidas",
    "Micro / Cyclic Feeding": "Alimentación micro / cíclica",
    "Meal Feeding: pellets go out in a few discrete meals across the day. Micro / Cyclic Feeding: feed is spread into many small, repeating deliveries.":
      "Alimentación por comidas: los pellets se reparten en unas pocas comidas concretas a lo largo del día. Alimentación micro / cíclica: el alimento se reparte en muchas entregas pequeñas y repetidas.",
    "Minimum time between visits": "Tiempo mínimo entre visitas",
    "Optional. The shortest gap allowed between two feeding visits on the same cage. Leave blank for no minimum.":
      "Opcional. El intervalo más corto permitido entre dos visitas de alimentación en la misma jaula. Déjalo en blanco para no aplicar mínimo.",
    "Total Groups": "Grupos totales",
    "Total Visits": "Visitas totales",
    "Average Visit": "Visita promedio",
    "Group Start Time": "Hora de inicio del grupo",
    "Group End Time": "Hora de fin del grupo",
    "Group Feed %": "% de alimento del grupo",
    "Number of Visits": "Número de visitas",
    "Give this feeding plan a name so you can find it later. Something like 'summer plan' or 'small fish' works well.":
      "Dale un nombre a este plan de alimentación para poder encontrarlo después. Algo como 'plan de verano' o 'peces pequeños' funciona bien.",
    "Earliest time of day the fish are allowed to be fed.":
      "Hora más temprana del día a la que se puede alimentar a los peces.",
    "Latest time of day feeding is allowed. After this, no more pellets go out.":
      "Hora más tardía del día en la que se permite alimentar. Después de esta hora, no salen más pellets.",
    "Fixed: you type in the total kilograms of feed per day. Growth Model: the system works out the amount from how much the fish weigh and how fast they grow.":
      "Fijo: escribes los kilos totales de alimento por día. Modelo de crecimiento: el sistema calcula la cantidad según el peso de los peces y su velocidad de crecimiento.",
    "Total kilograms of feed to hand out today across every cage on the feedline.":
      "Kilos totales de alimento a repartir hoy entre todas las jaulas de la línea.",
    "How fast pellets can be fed, in {{unit}}. This is usually the feeding machine's normal speed.":
      "Velocidad a la que se pueden dar los pellets, en {{unit}}. Normalmente es la velocidad habitual de la máquina de alimentación.",
    "Defaults use kg/min or g/s. Change unit in Feed Settings to use {{unit}}.":
      "Los valores predeterminados usan kg/min o g/s. Cambia la unidad en Ajustes de alimentación para usar {{unit}}.",
    "No default": "Sin predeterminado",
    "How much extra above the daily target the system may feed if the fish are still hungry. 15% means it can go up to 15% over the target.":
      "Cuánto extra por encima del objetivo diario puede alimentar el sistema si los peces siguen con hambre. 15% significa que puede llegar hasta un 15% por encima del objetivo.",
    "ON: visits are packed tightly across the day so feeding time is used efficiently. OFF: visits stay inside the group time windows you set.":
      "ON: las visitas se agrupan juntas a lo largo del día para aprovechar el tiempo de alimentación. OFF: las visitas se mantienen dentro de las ventanas de tiempo que hayas configurado por grupo.",
    "Only matters when you add a new cage to the feedline. ON: the new cage keeps the feed rate the other cages were already using. OFF: the new cage starts from the base feed rate above.":
      "Solo importa cuando añades una jaula nueva a la línea. ON: la jaula nueva mantiene la velocidad de alimentación que ya usaban las otras jaulas. OFF: la jaula nueva empieza desde la velocidad base de arriba.",
    "How many feeding sessions per day you have set up below.":
      "Cuántas sesiones de alimentación por día tienes configuradas abajo.",
    "Total number of pellet deliveries across the whole day.":
      "Número total de entregas de pellets en todo el día.",
    "Average kilograms of feed handed out per visit. Just the daily target split evenly across all visits.":
      "Kilos promedio de alimento repartidos por visita. Es el objetivo diario dividido a partes iguales entre todas las visitas.",
    "Time this group of feeding visits begins.":
      "Hora en la que empieza este grupo de visitas de alimentación.",
    "Time this group of feeding visits ends.":
      "Hora en la que termina este grupo de visitas de alimentación.",
    "Share of the daily target that belongs to this group. All groups together should add up to 100%.":
      "Parte del objetivo diario que corresponde a este grupo. Todos los grupos juntos deben sumar 100%.",
    "How many separate feed deliveries happen inside this group. More visits = smaller portions each time.":
      "Cuántas entregas de alimento separadas ocurren dentro de este grupo. Más visitas = porciones más pequeñas cada vez.",
    "End must be after start": "El final debe ser posterior al inicio",
    "Can't add a visit in the past":
      "No se puede añadir una visita en el pasado",
    "Can't move a visit into the past":
      "No se puede mover una visita al pasado",
    "Overlaps a visit on this feedline":
      "Se superpone con una visita en esta línea de alimentación",
    "Pen is at its feed target — no room":
      "La jaula está en su objetivo de alimentación — sin margen",
    "The added visit exceeds the feed amount remaining in this pen":
      "La visita añadida supera la cantidad de alimento restante en esta jaula",
    "The visit exceeds the feed amount remaining in this pen":
      "La visita supera la cantidad de alimento restante en esta jaula",
    "Can't add a cluster in the past":
      "No se puede añadir un clúster en el pasado",
    "Can't move a cluster into the past":
      "No se puede mover un clúster al pasado",
    "Overlaps another cluster in this pen":
      "Se superpone con otro clúster en esta jaula",
    "A cluster must sit inside one feeding group's window":
      "Un clúster debe estar dentro de la ventana de un grupo de alimentación",
    "Outside the schedule's feeding window":
      "Fuera de la ventana de alimentación de la programación",
    Start: "Inicio",
    End: "Fin",
    "Feed · feed rate {{rate}} kg/min × duration · max {{headroom}} kg of {{target}} kg target":
      "Alimento · tasa {{rate}} kg/min × duración · máx {{headroom}} kg de {{target}} kg objetivo",
    "Group window {{window}}": "Ventana del grupo {{window}}",
    "No feeding group covers this window":
      "Ningún grupo de alimentación cubre esta ventana",
    "{{count}} visits · {{kg}} kg_one": "{{count}} visita · {{kg}} kg",
    "{{count}} visits · {{kg}} kg_other": "{{count}} visitas · {{kg}} kg",
    "no visits": "sin visitas",
    "{{minutes}} min · ~{{cadence}} min apart":
      "{{minutes}} min · ~{{cadence}} min de separación",
    "{{minutes}} min": "{{minutes}} min",
    "~{{cadence}} min apart": "~{{cadence}} min de separación",
    "{{kg}} kg/visit": "{{kg}} kg/visita",
    optional: "opcional",
    "e.g. catch-up feed, vet requested…":
      "p. ej. alimentación de recuperación, solicitado por el veterinario…",
    "e.g. bad weather, pen treated…": "p. ej. mal tiempo, jaula tratada…",
    "Add visit": "Añadir visita",
    "Add cluster": "Añadir clúster",
    "Schedule change rejected": "Cambio de programación rechazado",
    Idle: "Inactivo",
    "{{count}} pen_one": "{{count}} jaula",
    "{{count}} pen_other": "{{count}} jaulas",
    "Delete this visit?": "¿Eliminar esta visita?",
    "Delete visit": "Eliminar visita",
    "Delete this cluster?": "¿Eliminar este clúster?",
    "Delete cluster": "Eliminar clúster",
    "Feed rate (kg/min)": "Tasa de alimentación (kg/min)",
    "{{kg}} kg planned": "{{kg}} kg planificados",
    "Daily feed target (kg)": "Objetivo diario de alimentación (kg)",
    "Feeding ends": "La alimentación termina",
    "Target met": "Objetivo alcanzado",
    Close: "Cerrar",
    "Click to change the daily feed target":
      "Haz clic para cambiar el objetivo diario de alimentación",
    "Click to change the feed rate":
      "Haz clic para cambiar la tasa de alimentación",
    "No feedings": "Sin alimentaciones",
    Blower: "Soplador",
    "Not currently allowed in micro feeding":
      "No permitido actualmente en microalimentación",
    "{{hours}}h {{minutes}}m": "{{hours}} h {{minutes}} min",
    "{{minutes}}m": "{{minutes}} min",
    "Feeding ends {{label}}": "La alimentación termina {{label}}",
    "Estimate if fed at appetite factor 1":
      "Estimación si se alimenta con factor de apetito 1",
    "Drag to defer the remaining feed to later":
      "Arrastra para aplazar el alimento restante",
    "Drag to move · click to edit or delete":
      "Arrastra para mover · haz clic para editar o eliminar",
    "Drag to change the start time": "Arrastra para cambiar la hora de inicio",
    "Drag to extend the remaining feed":
      "Arrastra para extender el alimento restante",
    "Drag to extend the cluster": "Arrastra para extender el clúster",
    "Drag to change the end time": "Arrastra para cambiar la hora de fin",
    "Feed target met": "Objetivo de alimentación alcanzado",
    "{{delta}} kg over target": "{{delta}} kg por encima del objetivo",
    "{{delta}} kg to reach target": "{{delta}} kg para alcanzar el objetivo",
    "target {{target}} kg": "objetivo {{target}} kg",
    Fish: "Peces",
    System: "Sistema",
    "Feed line": "Línea de Alimentación",
    "Relative Activity": "Actividad Relativa",
    "Trend (Short)": "Tendencia (Corto)",
    "Trend (Med)": "Tendencia (Medio)",
    "Trend (Long)": "Tendencia (Largo)",
    "# of Fish": "N.º de Peces",
    "Relative Visibility": "Visibilidad Relativa",
    Schooling: "Cardumen",
    Distance: "Distancia",
    Speed: "Velocidad",
    "Feed (kg/min)": "Alimento (kg/min)",
    "Feed (g/s)": "Alimento (g/s)",
    "Feed (p/fish/min)": "Alimento (p/pez/min)",
    "Feed (kg/t/min)": "Alimento (kg/t/min)",
    "Total Feed": "Alimento Total",
    "Feed Score": "Puntuación de Alimentación",
    "Appetite Adjustment": "Ajuste de Apetito",
    "Visit Feed (g)": "Alimento por Visita (g)",
    "Visit Number": "Número de Visita",
    "Remaining Visits": "Visitas Restantes",
    Salinity: "Salinidad",
    Saturation: "Saturación",
    Pressure: "Presión",
    "Average Weight": "Peso Promedio",
    "Condition Factor": "Factor de Condición",
    "Coefficient of Variation": "Coeficiente de Variación",
    "Specific Growth Rate": "Tasa de Crecimiento Específico",
    "Relative Growth Index": "Índice de Crecimiento Relativo",
    "Growth Rate": "Tasa de Crecimiento",
    "Total Lice": "Piojos Totales",
    "Air Speed (m/s)": "Velocidad del Aire (m/s)",
    "Water Flow (m³/h)": "Caudal de Agua (m³/h)",
    "Water Flow [m³/h]": "Caudal de Agua [m³/h]",
    "Silo Level (%)": "Nivel de Silo (%)",
    "Line status": "Estado de la Línea",
    Compare: "Comparar",
    "Total feed amount compared to yesterday":
      "Cantidad total de alimento comparada con ayer",
    Today: "Hoy",
    Yesterday: "Ayer",
    "Hide from chart": "Ocultar del gráfico",
    "Show in chart": "Mostrar en el gráfico",
    Feedline: "Línea de alimentación",
    Schedules: "Programaciones",
    Active: "Activo",
    OK: "Aceptar",
    "is required": "es obligatorio",
    "must be a number": "debe ser un número",
    "must be at least": "debe ser al menos",
    "must be at most": "debe ser como máximo",
    "must be greater than": "debe ser mayor que",
    "must be a whole number": "debe ser un número entero",
    "can have at most": "puede tener como máximo",
    "decimal place": "decimal",
    "decimal places": "decimales",
    Discard: "Descartar",
    Finish: "Finalizar",
    Overshoot: "Exceso",
    Scheduler: "Programador",
    sec: "seg",
    min: "min",
    "Feed Now": "Alimentar ahora",
    "Add Back": "Volver a añadir",
    "Apply to All": "Aplicar a todos",
    "Catch Up": "Recuperar",
    "Start Time": "Hora de inicio",
    "End Time": "Hora de fin",
    "Planned Feed": "Alimentación planificada",
    "Target Feed": "Alimentación objetivo",
    "Percentage Total": "Porcentaje total",
    "New Schedule": "Nueva programación",
    "Wait Block": "Bloque de espera",
    "Advanced Settings": "Configuración avanzada",
    "Schedule name": "Nombre de la programación",
    "Time Between Visits": "Tiempo entre visitas",
    "Minimum time to wait between consecutive feeding visits to this pen when go to next is triggered. Visits are spaced so the feeder pauses at least this long before feeding.":
      "Tiempo mínimo de espera entre visitas de alimentación consecutivas a esta jaula cuando se activa «ir a la siguiente». Las visitas se espacian para que el alimentador haga una pausa de al menos este tiempo antes de alimentar.",
    "Save schedule?": "¿Guardar programación?",
    "Are you sure you want to save the changes to this schedule?":
      "¿Seguro que quieres guardar los cambios en esta programación?",
    "Planned feed deviates from expected":
      "La alimentación planificada se desvía de lo esperado",
    "Review feed deviation warnings before saving":
      "Revisa las advertencias de desviación de alimentación antes de guardar",
    "Cannot save schedule": "No se puede guardar la programación",
    "Resolve the following errors before saving":
      "Resuelve los siguientes errores antes de guardar",
    "Save Anyway": "Guardar de todos modos",
    "Decrease Feed Rate or Feed Time":
      "Reduce la tasa de alimentación o el tiempo de alimentación",
    "Increase Feed Rate or Feed Time":
      "Aumenta la tasa de alimentación o el tiempo de alimentación",
    "This will clear all visits for this feed line":
      "Esto borrará todas las visitas de esta línea de alimentación",
    "No Feedline Found": "No se encontró ninguna línea de alimentación",
    "No Feedlines Found": "No se encontraron líneas de alimentación",
    "No Pens Found": "No se encontraron jaulas",
    "No Schedules Found": "No se encontraron programaciones",
    "All unsaved changes will be lost.":
      "Se perderán todos los cambios no guardados.",
    "You have unsaved changes to this group. Closing will discard them.":
      "Tienes cambios sin guardar en este grupo. Si cierras, se descartarán.",
    "There is currently no selected active schedule for this feedline":
      "Actualmente no hay ninguna programación activa seleccionada para esta línea de alimentación",
    "Group percentages must add up to 100%":
      "Los porcentajes de los grupos deben sumar 100 %",
    "Every group must have at least one visit":
      "Cada grupo debe tener al menos una visita",
    "Start time is required": "La hora de inicio es obligatoria",
    "End time is required": "La hora de fin es obligatoria",
    "Visits must be greater than 0": "Las visitas deben ser mayores que 0",
    "Percentage must be at least 0": "El porcentaje debe ser al menos 0",
    "Cannot exceed {{max}}%": "No puede superar el {{max}} %",
    "Planned feed is {{percent}}% above expected":
      "La alimentación planificada está un {{percent}} % por encima de lo esperado",
    "Planned feed is {{percent}}% below expected":
      "La alimentación planificada está un {{percent}} % por debajo de lo esperado",
    "Cage {{cageId}}": "Jaula {{cageId}}",
    "Fix: {{fix}}": "Solución: {{fix}}",
    'This will permanently delete the schedule "{{name}}". This action cannot be undone.':
      'Esto eliminará permanentemente la programación "{{name}}". Esta acción no se puede deshacer.',
    "{{count}} seconds_one": "{{count}} segundo",
    "{{count}} seconds_other": "{{count}} segundos",
    Continue: "Continuar",
    "Saved — with changes": "Guardado — con cambios",
    "Your change was saved. The following adjustments were made:":
      "Se guardó tu cambio. Se realizaron los siguientes ajustes:",
    "Fed so far: {{fedKg}} kg": "Alimentado hasta ahora: {{fedKg}} kg",
    "Planned: {{plannedKg}} kg": "Planificado: {{plannedKg}} kg",
    "Target: {{targetKg}} kg": "Objetivo: {{targetKg}} kg",
    "Overshoot: {{overshootPct}} %": "Exceso: {{overshootPct}} %",
    "Planned Feed - {{plannedKg}} kg":
      "Alimentación planificada - {{plannedKg}} kg",
    "Target Feed - {{targetKg}} kg": "Alimentación objetivo - {{targetKg}} kg",
    "Overshoot - {{overshootPct}} %": "Exceso - {{overshootPct}} %",
    Cluster: "Clúster",
    "op.itemDesc": "{{type}} {{start}}-{{end}} ({{pen}})",
    "op.dayWindow.outsideDay":
      "{{item}} queda fuera de la ventana de alimentación ({{dayStart}}-{{dayEnd}}). Muévelo o acórtalo para que encaje en ese horario.",
    "op.dayWindow.outsideGroup":
      "{{item}} queda fuera de la ventana de su grupo de alimentación ({{groupStart}}-{{groupEnd}}). Muévelo o acórtalo para que encaje en ese horario.",
    "op.adjacent.snappedLine":
      "{{item}} se ajustó para empezar a las {{legalStart}} de modo que quede justo después de {{other}} en la línea de alimentación compartida.",
    "op.adjacent.snappedPen":
      "{{item}} se ajustó para empezar a las {{legalStart}} de modo que quede justo después de {{other}} en la misma jaula.",
    "op.contention.overlapLine":
      "{{item}} se solapa con {{other}} en la línea de alimentación compartida — solo una visita puede ejecutarse a la vez.",
    "op.contention.overlapPen":
      "{{item}} se solapa con {{other}} en la misma jaula — los clústeres no pueden solaparse.",
    "op.contention.blowerGap":
      "{{item}} empieza solo {{gap}} s después de {{other}} en la línea de alimentación compartida. Jaulas distintas necesitan al menos {{requiredGap}} s entre visitas para que la línea se despeje — sepáralas más.",
    "op.inverted":
      "{{item}} termina en o antes de empezar. Dale una hora de fin posterior a su inicio.",
    "op.waitBlock":
      "{{item}} empieza durante un bloque de espera ({{blockStart}}-{{blockEnd}}). El bloque de espera se acortará para terminar cuando empiece la visita.",
    "op.groupWindow.noGroup":
      "{{item}} no cae dentro de ningún grupo de alimentación de esta jaula. Muévelo a las horas de un grupo de alimentación para guardar.",
    "op.groupWindow.trimmed":
      "{{item}} se acortó a {{start}}-{{end}} ({{minutes}} min) para encajar dentro de su grupo de alimentación ({{groupStart}}-{{groupEnd}}).",
    "op.dailyTarget.exceeded":
      "{{pen}} está configurado para alimentar {{plannedKg}} kg. El objetivo diario es {{targetKg}} kg — elimina o acorta una visita para reducirlo.",
    "op.dailyTarget.noTarget":
      "{{pen}} no tiene objetivo de alimentación para hoy, por lo que no se puede guardar su objetivo operativo.",
    "op.schedule.notOnFeedline":
      "El horario cargado para {{feedLineId}} no es el horario activo de esa línea de alimentación. Actualiza la página y vuelve a hacer el cambio.",
    "Live Pellets": "Pellets en vivo",
    "Co-pilot": "Copiloto",
    "Feed Amount (Kg)": "Cantidad de alimento (kg)",
    "Temperature (°C)": "Temperatura (°C)",
    "Visits Total": "Total de visitas",
    "Pipe Pressure Bar": "Presión de tubería (bar)",
    "Oxygen (mg/L)": "Oxígeno (mg/L)",
    "Feed Mode": "Modo de alimentación",
    "Line Status": "Estado de la línea",
    "Visit (Kg)": "Visita (kg)",
    "Next Scenario": "Siguiente escenario",
    AF: "AF",
    Table: "Tabla",
    Timeline: "Cronología",
    "Start feeding": "Iniciar alimentación",
    "Pause feeding": "Pausar alimentación",
    "Stop feeding": "Detener alimentación",
    "More options": "Más opciones",
    "Reset to original schedule": "Restablecer a la programación original",
    "Stop feed for the whole day": "Detener alimentación durante todo el día",
    Catchup: "Recuperar",
    "Restores all planned feed after now":
      "Restaura toda la alimentación planificada a partir de ahora",
    "How much in Kg has been fed this visit":
      "Cuántos kg se han alimentado en esta visita",
    "How much in Kg has been fed today": "Cuántos kg se han alimentado hoy",
    "Lets you visualise the graph(s) selected in the column selector, for current feed rate and/or pressure for each pen":
      "Permite visualizar los gráficos seleccionados en el selector de columnas, para la tasa de alimentación actual y/o la presión de cada jaula",
    "CO-PILOT": "COPILOTO",
    "This feature lets you run predefined strategies to achieve better results with less manual effort.":
      "Esta función permite ejecutar estrategias predefinidas para obtener mejores resultados con menos esfuerzo manual.",
    "Use this table to change strategy, scenario, or feed mode while in copilot mode. Toggle off co-pilot in this table to bring the pen back to manual feeding mode.":
      "Usa esta tabla para cambiar la estrategia, el escenario o el modo de alimentación mientras estás en modo copiloto. Desactiva el copiloto en esta tabla para devolver la jaula al modo de alimentación manual.",
    "FEED PAGE": "PÁGINA DE ALIMENTACIÓN",
    "This page helps you manage line statuses, feed rates, and the Co-pilot function.":
      "Esta página te ayuda a gestionar los estados de las líneas, las tasas de alimentación y la función Copiloto.",
    "This Screen": "Esta pantalla",
    "Entire Setup": "Toda la configuración",
    "No templates saved yet": "Aún no hay plantillas guardadas",
    "Save Current Layout": "Guardar diseño actual",
    "Save Current Screen…": "Guardar pantalla actual…",
    "Save Layout Template": "Guardar plantilla de diseño",
    "Save Screen Layout Template": "Guardar plantilla de diseño de pantalla",
    "Template Name": "Nombre de la plantilla",
    "Enter template name...": "Introduzca el nombre de la plantilla...",
    "Please enter a template name": "Introduzca un nombre de plantilla",
    "Template name must be 50 characters or less":
      "El nombre de la plantilla debe tener 50 caracteres o menos",
    "Save Template": "Guardar plantilla",
    "Delete Template": "Eliminar plantilla",
    "Delete Screen Template": "Eliminar plantilla de pantalla",
    'Are you sure you want to delete the template "{{templateName}}"? This action cannot be undone.':
      '¿Seguro que desea eliminar la plantilla "{{templateName}}"? Esta acción no se puede deshacer.',
    "Select Template": "Seleccionar plantilla",
    "Loading...": "Cargando...",
    "Deleting...": "Eliminando...",
    Surface: "Superficie",
    Barge: "Barcaza",
    Other: "Otro",
    Subsurface: "Submarina",
    "Subsurface - top (looking up)":
      "Submarina - superior (mirando hacia arriba)",
    "Subsurface - bottom (looking down)":
      "Submarina - inferior (mirando hacia abajo)",
    "Camera Model": "Modelo de cámara",
    "Connect Exit Good to a scenario before saving its conditions":
      "Conecta Exit Good a un escenario antes de guardar sus condiciones",
    "Connect Exit Bad to a scenario before saving its conditions":
      "Conecta Exit Bad a un escenario antes de guardar sus condiciones",
    "Add an exit condition before adding a pause":
      "Agrega una condición de salida antes de agregar una pausa",
    "4-digit PIN": "PIN de 4 dígitos",
    "Back to saved accounts": "Volver a las cuentas guardadas",
    "Change PIN": "Cambiar PIN",
    "Choose a PIN": "Elige un PIN",
    "Choose an account to continue.": "Elige una cuenta para continuar.",
    "Confirm your PIN": "Confirma tu PIN",
    "Couldn't set up your PIN.": "No se pudo configurar tu PIN.",
    "Enter the same 4 digits again.":
      "Introduce los mismos 4 dígitos otra vez.",
    "Enter your PIN": "Introduce tu PIN",
    "Enter your password": "Introduce tu contraseña",
    "Failed to cancel sign-in": "No se pudo cancelar el inicio de sesión",
    "Failed to forget this email": "No se pudo olvidar este correo electrónico",
    "Failed to reset password": "No se pudo restablecer la contraseña",
    "Failed to set new password": "No se pudo establecer la nueva contraseña",
    "Failed to set up authenticator": "No se pudo configurar el autenticador",
    "Failed to start password reset":
      "No se pudo iniciar el restablecimiento de la contraseña",
    "Failed to verify code": "No se pudo verificar el código",
    "Forget this email": "Olvidar este correo electrónico",
    "Forgot password?": "¿Olvidaste tu contraseña?",
    "Incorrect PIN.": "PIN incorrecto.",
    "Attempts left:": "Intentos restantes:",
    "Log in": "Iniciar sesión",
    "Log in with a different email":
      "Iniciar sesión con otro correo electrónico",
    "Log in with password": "Iniciar sesión con contraseña",
    "Not now": "Ahora no",
    "Offline login isn't available on this device yet. Log in online first.":
      "El inicio de sesión sin conexión aún no está disponible en este dispositivo. Inicia sesión con conexión primero.",
    PIN: "PIN",
    Password: "Contraseña",
    "Password login needs an internet connection.":
      "El inicio de sesión con contraseña necesita conexión a internet.",
    "Pick 4 digits you will remember. Used on this device only.":
      "Elige 4 dígitos que recuerdes. Solo se usa en este dispositivo.",
    "Set up PIN": "Configurar PIN",
    "Set up quick login?": "¿Configurar el inicio de sesión rápido?",
    "Sign-in failed": "Error al iniciar sesión",
    "Signing in as": "Iniciando sesión como",
    "Skip for now": "Omitir por ahora",
    "Skip typing your password next time — sign in with a 4-digit PIN on this device.":
      "No escribas tu contraseña la próxima vez: inicia sesión con un PIN de 4 dígitos en este dispositivo.",
    "Those PINs did not match. Start again.":
      "Los PIN no coinciden. Empieza de nuevo.",
    "Too many incorrect attempts. Log in with your password when you're back online.":
      "Demasiados intentos incorrectos. Inicia sesión con tu contraseña cuando vuelvas a tener conexión.",
    "Too many incorrect attempts. Log in with your password.":
      "Demasiados intentos incorrectos. Inicia sesión con tu contraseña.",
    "Welcome back": "Bienvenido de nuevo",
    "Your offline session has expired. Log in with your password when you're back online.":
      "Tu sesión sin conexión ha caducado. Inicia sesión con tu contraseña cuando vuelvas a tener conexión.",
    "Your password has been reset. Please log in.":
      "Tu contraseña se ha restablecido. Inicia sesión.",
    "Your password must be reset before you can log in.":
      "Debes restablecer tu contraseña antes de iniciar sesión.",
    "Your quick login has expired. Log in with your password to renew it.":
      "Tu inicio de sesión rápido ha caducado. Inicia sesión con tu contraseña para renovarlo.",
  },
};
